import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../features/store";
import { USER } from "../features/User/slice";

const useRole = () => {
  const { userProfile } = useSelector((state: RootState) => state[USER]);

  const isOwner = useMemo(() => {
    return userProfile?.userType === "Master";
  }, [userProfile]);

  const isAdmin = useMemo(() => {
    return userProfile?.userType === "SubMaster";
  }, [userProfile]);

  const isDriver = useMemo(() => {
    return userProfile?.userType === "User";
  }, [userProfile]);

  return {
    isOwner,
    isAdmin,
    isDriver,
  };
};

export default useRole;
